export class WorkAttachmentModel {
    id: number ;
    name: string ;
    type: string ;
    version: string ;
    date: Date ;
}
